import {initSliderPDP} from "../helpers/service.slider";
import {addClass, ajax, event, hasClass, removeClass, selectArr, selectDoc, toggleClass} from "../utils/utils";
import {handleize} from "../helpers/service.validator";
import {addCartItemData, formatMoney} from "../helpers/service.cart";

/**
 *
 */
export class PDPSimple {
    /**
     *
     * @param PDP
     */
    constructor(PDP) {
        this.initializer(PDP);
    }

    /**
     *
     * @param PDP
     */
    simpleSlider(PDP) {
        //Remove product and hand iframes
        if (PDP.productSlider) {
            PDP.productSlider.parentNode ? PDP.productSlider.parentNode.removeChild(PDP.productSlider) : '';
        }
        if (PDP.handSlider) {
            PDP.handSlider.parentNode ? PDP.handSlider.parentNode.removeChild(PDP.handSlider) : '';
        }

        //Show one slide
        let slides = selectArr('#product-images-slider ul li'),
            simple3dIframe = selectDoc(PDP.main + ' #simple3d');

        slides.map(slide => {
            let slideImg = selectDoc(PDP.main + ' img:not(.variant-img)', slide);
            if (slideImg) {
                // if (!slideImg.getAttribute('data-src') || !slideImg.getAttribute('data-src').includes('carousel')) {
                //     slide.parentNode.removeChild(slide);
                // }
            }
        });

        slides = selectArr('#product-images-slider ul li');
        PDP.glideSlider = initSliderPDP('#product-images-slider', {
            perView: 1,
            type: 'slider',
            rewind: true,
            bound: true
        }, false, null, PDP);

        if (slides.length === 1) {
            PDP.slidesControls.style.display = 'none';
        }

        if (!simple3dIframe && !selectDoc(PDP.main + ' #is-gemstone')) {
            addClass(PDP.sliderImages, 'no-iframe')
        }

        addClass(PDP.sliderImages, 'show');
        PDP.sliderInitiated = true;

        if (simple3dIframe) {
          simple3dIframe.src = simple3dIframe.src;
        }
    }

    /**
     * Get actual selected variant (dynamic)
     * @param isOption
     * @param PDP
     * @returns {null|*}
     */
    getCurrentVariantDynamic(isOption = false, PDP) {
        /**
         * Selected Variants
         */
        let selectedVariants = selectArr(PDP.main + ' .tab input.variant.selected'),
            availableVariants = selectArr(PDP.main + ' select[name="id"] option'),
            handle = '';
        selectedVariants.map(v => {
            if (v.getAttribute('data-target')) {
                handle += v.getAttribute('data-target') + ' '
            }
        });

        handle = `option-${handleize(handle.trim())}`;

        let option = availableVariants.find(variant => variant.id === handle);
        if (option) {
            if (isOption) {
                return option;
            }
            return this.metafields.diamonds.find(diamond => diamond.variant.replace('V', '') === option.value);
        } else {
            return null;
        }
    }

    /**
     * Process variants data
     * @returns {Promise<void>}
     */
    initVariants(PDP) {
        let self = PDP;
        try {
            let productDataVariants = selectArr(PDP.main + ' #product-custom-data data'),
                productData = {
                    "product_type": self.type,
                    "sub_category": self.productSubCategory.value.toUpperCase(),
                    "diamonds": [],
                    "color": [
                        {
                            "value": "white-gold"
                        },
                        {
                            "value": "yellow-gold"
                        },
                        {
                            "value": "rose-gold"
                        }
                    ]
                };

            productDataVariants.map(productVariant => {
                let verlasFields = JSON.parse(productVariant.value.replace(/=>/g, ':'));
                productData.diamonds.push({
                    "variant": productVariant.getAttribute('data-id'),

                    "clarity": verlasFields.clarity,
                    "weight": verlasFields.carat,
                    "metal": verlasFields.metal,

                    "3d_product_image": verlasFields.product_aws ? verlasFields.product_aws.trim() : null,
                    "3d_hand_image": verlasFields.hand_aws ? verlasFields.hand_aws.trim() : null,

                    "raw_material": verlasFields.raw_materials_cost,
                    "labor": verlasFields.labor_cost,
                    "duty": verlasFields.warehouse_cost,
                    "retailer": verlasFields.retailer_price,
                    "designer": verlasFields.designer_price,
                    "margin": verlasFields.margin,
                    "total": verlasFields.verlas_price,

                    "total_carat_weight": verlasFields.total_carat_weight,
                    "primary_diamond": verlasFields.primary_diamond,
                    "primary_diamond_setting": verlasFields.primary_diamond_setting,
                    "primary_diamond_shape": verlasFields.primary_diamond_shape,
                    "secondary_diamond": verlasFields.secondary_diamond,
                    "secondary_diamond_setting": verlasFields.secondary_diamond_setting,
                    "secondary_diamond_shape": verlasFields.secondary_diamond_shape,
                    "width_x_height": verlasFields.width_x_height,
                    "number_diamonds": verlasFields.secondary_diamonds,
                    "primary_gemstone_clarity": verlasFields.primary_gemstone_clarity,
                    "secondary_gemstone_clarity": verlasFields.secondary_gemstone_clarity,
                    "secondary_gemstone_type": verlasFields.secondary_gemstone_type,
                    "secondary_gemstone_weight": verlasFields.secondary_gemstone_weight
                })
            })

            //Sort  by total price
            productData.diamonds.sort(function (a, b) {
                let priceA = parseInt(a.total),
                    priceB = parseInt(b.total);

                if (priceA < priceB) {
                    return -1;
                } else if (priceA > priceB) {
                    return 1;
                } else {
                    return 0;
                }
            });

            this.metafields = productData;

            if (productData.diamonds.length > 1) {
                if (PDP.isTAH()) {
                    if (productData.sub_category.includes('RING') && !productData.sub_category.includes('EARRING')) {
                        PDP.verlasIsRing = true;
                        addClass(PDP.body, 'is-ring-page')
                    }
                } else {
                    if (productData.product_type.includes('Ring') && !productData.product_type.includes('Earring')) {
                        PDP.verlasIsRing = true;
                        addClass(PDP.body, 'is-ring-page')
                    }
                }

                PDP.processVariants();
                PDP.initTabSystem();
                this.showVariantData(PDP);

                if (PDP.verlasIsRing) {
                    addClass(PDP.engrave, 'show')
                    addClass(PDP.size, 'show')
                    PDP.initEngraving();
                    PDP.reHeight();
                } else {
                    if(selectDoc(PDP.main + ' #set-products') && selectDoc(PDP.main + ' .tab#size')) {
                        let tabsCount = selectArr(PDP.main + ' .tabs .tab'),
                            engravePos = selectDoc('.tab-number label', PDP.engrave)
                        engravePos.innerHTML = tabsCount.length;
                        addClass(PDP.engrave, 'show')
                        PDP.initEngraving();
                        PDP.reHeight();
                    }
                }

                PDP.initAddToCart();
            } else {
                PDP.updateDynamicFields(null);
                this.simpleSlider(PDP);
                PDP.initAddToCart();
            }
        } catch (e) {
            console.log('Error fetching simple product data.', e)
        }
    }

    /**
     *
     * @param variant
     * @param PDP
     */
    processVariant(variant, PDP) {
        let selectedOption = this.getCurrentVariantDynamic(true, PDP);
        if (selectedOption) {
            let total = selectedOption.getAttribute('data-price');
            selectArr('.pdp-price').map(price => {
                price.innerHTML = '$' + formatMoney(total, 0)
            })
            selectedOption.selected = true;
        }

        try {
            let summary = selectDoc(PDP.main + ` .tab#${variant.getAttribute('data-type')} .tab-summary label`),
                label = selectDoc('label', variant.parentNode.parentNode);

            if (summary && label) {
                if(variant.getAttribute('data-type').includes('setmetalcolor')) {
                    summary.innerText = label.innerText.trim() + ' Gold';
                } else {
                    summary.innerText = label.innerText.trim();
                }
            }
        } catch (e) {

        }
    }

    /**
     * Check browser url params and search for variant
     */
    checkVariantUrl(PDP) {
        let params = new URL(document.URL).searchParams,
            colorParam = params.get('color') ? params.get('color') : 'white-gold',
            gemstoneParam = params.get('gemstone') ? params.get('gemstone') : null;

        if (params.get('v')) {
            let curV = this.metafields.diamonds.find(diamond => diamond.variant === params.get('v'));
            if (curV) {
                let opt = selectDoc(PDP.main + ` option[value="${curV.variant.replace('V', '')}"]`);
                if (opt) {
                    opt.innerText.split('/').map(ov => {
                        let optCode = ov.trim()
                                .replaceAll(' ', '')
                                .replaceAll('_', '')
                                .replaceAll('-', '')
                                .replaceAll('/', '')
                                .toUpperCase(),
                            btn = selectDoc(PDP.main + ` .tab.show input[data-target="${optCode}"]`);
                        btn ? addClass(btn, 'selected') : '';
                        btn ? addClass(btn.parentNode.parentNode, 'selected') : '';
                        btn ? btn.click() : '';
                    })
                }

                let color = selectDoc(PDP.main + ` #metal-color input[data-v="${colorParam}"]`)
                color ? addClass(color, 'selected') : '';
                color ? addClass(color.parentNode.parentNode, 'selected') : '';
                color ? color.click() : '';

                let gemstone = selectDoc(PDP.main + ` #primarystone input[data-target="${gemstoneParam}"]`)
                gemstone ? addClass(gemstone, 'selected') : '';
                gemstone ? addClass(gemstone.parentNode.parentNode, 'selected') : '';
                gemstone ? gemstone.click() : '';
            }
        }

        PDP.urlCheked = true;
    }

    /**
     * Show current variant data
     */
    showVariantData(PDP = null) {
        let self = this,
            variant = self.getCurrentVariantDynamic(false, PDP);

        if (variant) {
            selectArr('img.variant-img').map(vi => {
                addClass(vi, 'hide-variant-img')
            })

            let vImage = selectDoc(PDP.main + ` #img-variant-${variant.variant.replace('V', '')}`);
            if (vImage) {
                removeClass(vImage, 'hide-variant-img');
                vImage.src = vImage.getAttribute('data-src')
                removeClass(vImage, 'lazy-load');
                PDP.glideSlider ? PDP.glideSlider.go('>>') : '';
                if (window.innerWidth <= 768) {
                    window.scrollTo({
                        top: 0,
                        left: 0,
                        behavior: 'smooth'
                    });
                }
            }
        }

        if (variant && selectDoc(PDP.main + ' #is-gemstone')) {
            let color = selectDoc(PDP.currentMetalColor),
                gemstone = selectDoc(PDP.currentGemstone);

            if (!color && PDP.metalColor) {
                let firstColor = selectDoc(PDP.main + ' #metal-color button')
                firstColor ? firstColor.click() : '';
                color = firstColor;
            }

            /**
             * Update url variant
             */
            if (PDP.urlCheked && !PDP.isQuickView) {
                let state = `?v=${variant.variant}`
                color ? state += `&color=${color.getAttribute('data-v')}` : '';
                gemstone ? state += `&gemstone=${gemstone.getAttribute('data-target')}` : '';
                window.history.pushState({}, 'v', state);

                PDP.facebookUrl ? PDP.facebookShare.setAttribute('href', PDP.facebookUrl + `?variant=${encodeURIComponent(state)}`) : '';
                PDP.emailUrl ? PDP.emailShare.setAttribute('href', PDP.emailUrl + `${encodeURIComponent(state)}`) : '';
            }

            if (!PDP.isTAH()) {
                PDP.updateDynamicFields(variant);
                PDP.reHeight()
            }

            let fmetal = variant.metal,
                awsColorText = '',
                awsGemText = '',
                sumColor = '';
            if (PDP.isPlatinum(fmetal)) {
                awsColorText = 'Platinum';
                if (PDP.colorDisclaimer) {
                    PDP.colorDisclaimer.classList.add('show')
                    PDP.metalColor.classList.add('hide')
                }
            } else {
                let fcolor = selectDoc(PDP.main + ' #metal-color input.variant.selected');
                if (fcolor) {
                    fcolor = fcolor.getAttribute('data-v').replaceAll('-gold', '');
                    sumColor = `${fcolor.charAt(0).toUpperCase()}${fcolor.substr(1)}_Gold`;
                    awsColorText += fmetal ? `${fmetal.charAt(0).toUpperCase()}${fmetal.substr(1).toLowerCase()}` : '';
                    awsColorText += sumColor;
                }

                if (PDP.colorDisclaimer) {
                    PDP.colorDisclaimer.classList.remove('show')
                    PDP.metalColor.classList.remove('hide')
                }
            }

            let fgem = selectDoc(PDP.main + ' #primarystone input.variant.selected');
            if (fgem) {
                fgem = fgem.getAttribute('data-target');
                fgem = `${fgem.charAt(0).toUpperCase()}${fgem.substr(1).toLowerCase()}`;
                if (fgem.includes('sapphire')) {
                    fgem = 'Sapphire';
                }
                if (fgem.includes('topaz')) {
                    fgem = 'Topaz';
                }
                awsGemText += `Gem_Center_${fgem}`;
            }

            /**
             * Conditional Summaries
             */
            //Metal
            let metalSum = selectDoc(PDP.main + ` .tab#metal .tab-summary label`);
            if (metalSum) {
                let metalText = metalSum.innerText.split(',');
                metalSum.innerText = `${metalText[0].trim()}, ${sumColor.replace('_', ' ')}`;
            }

            //Primary Stone
            let psSum = selectDoc(PDP.main + ` .tab#primarystone .tab-summary label`),
                psdCurrent = selectDoc(PDP.main + ` #primarystonedimensions .radio-row.selected label`)
            if (psSum && psdCurrent) {
                let psText = psSum.innerText.split(',');
                psSum.innerText = `${psText[0]}, ${psdCurrent.innerText}`;
            }

            //Size
            let sizeSum = selectDoc(PDP.main + ` .tab#size .tab-summary label`),
                sizeCurrent = selectDoc(PDP.main + ` .tab#size .radio-row.selected label`)
            if (sizeSum && sizeCurrent) {
                sizeSum.innerText = sizeCurrent.innerText;
            }

            /**
             * Keep metal color and gemstone up to date
             */
            PDP.sliderInitiated ? PDP.updateIFrames(variant, awsColorText, 'both') : PDP.updateIFrames(variant)
            PDP.sliderInitiated ? PDP.updateIFrames(variant, awsGemText, 'both') : PDP.updateIFrames(variant)

            /**
             * Setup slider & iframe (one time only)
             */
            if (!PDP.sliderInitiated || PDP.isQuickView) {
                if (PDP.slides.length > 1) {
                    PDP.glideSlider = initSliderPDP('#product-images-slider', {
                        perView: 1,
                        type: 'slider',
                        rewind: true,
                        bound: true
                    }, false, null, PDP);
                } else {
                    PDP.slidesControls.style.display = 'none';
                }

                PDP.sliderInitiated = true;
                PDP.updateIFrames(variant);
                addClass(PDP.sliderImages, 'show')
            } else {
                /**
                 * Move slider to first slide
                 */
                let isHandActive = selectDoc(PDP.main + ' #slider .glide__slide--active #hand3d');
                if (!isHandActive) {
                    PDP.glideSlider ? PDP.glideSlider.go('<<') : ''
                }
            }

           self.processVariant(variant, PDP);
        } else {
            if (!PDP.sliderInitiated && !selectDoc(PDP.main + ' #is-gemstone')) {
                this.simpleSlider(PDP);
                PDP.updateDynamicFields(null);
                PDP.reHeight();
            }
        }

        //Affirm
        let selectedVariant = selectDoc(PDP.main + ` select[name='id']`)
        if (selectedVariant) {
            let opt = selectedVariant.options[selectedVariant.selectedIndex];
            PDP.verlasCurrentSize = opt;
            try {
                //Affirm
                selectDoc(PDP.main + ' .affirm-as-low-as').setAttribute('data-amount', opt.getAttribute('data-price'));
                affirm.ui.refresh();
            } catch (e) {}
        }
    }

    /**
     *
     * @param PDP
     */
    initSet(PDP) {
        const renderDynamicProps = (metafields, isGem) => {
            let m = metafields;
            return `
            ${m.primary_diamond ? `<p><span class="prop body3 body3-left">Primary ${isGem ? 'Gemstone' : 'Diamond Weight' }</span><span class="value body6 body6-left">${m.primary_diamond}</span></p>` : ``}
            ${m.secondary_diamond ? `<p><span class="prop body3 body3-left">Secondary ${isGem ? 'Gemstone' : 'Diamond Weight' }</span><span class="value body6 body6-left">${m.secondary_diamond}</span></p>` : ``}
            ${m.secondary_diamonds ? `<p><span class="prop body3 body3-left">Total # of ${isGem ? 'Gemstones' : 'Diamonds' }</span><span class="value body6 body6-left">${m.secondary_diamonds}</span></p>` : ``}
            ${m.primary_diamond_shape ? `<p><span class="prop body3 body3-left">Primary ${isGem ? 'Gemstone' : 'Diamond' } Shape</span><span class="value body6 body6-left">${m.primary_diamond_shape}</span></p>` : ``}
            ${m.secondary_diamond_shape ? `<p><span class="prop body3 body3-left">Secondary ${isGem ? 'Gemstone' : 'Diamond' } Shape</span><span class="value body6 body6-left">${m.secondary_diamond_shape}</span></p>` : ``}
            ${m.width_x_height ? `<p><span class="prop body3 body3-left">Jewelry Width x Height</span><span class="value body6 body6-left">${m.width_x_height}</span></p>` : ``}
            ${m.total_carat_weight ? `<p><span class="prop body3 body3-left">Total Carat Weight</span><span class="value body6 body6-left">${m.total_carat_weight}</span></p>` : ``}
            ${m.primary_diamond_setting ? `<p><span class="prop body3 body3-left">Primary ${isGem ? 'Gemstone' : 'Diamond' } Setting</span><span class="value body6 body6-left">${m.primary_diamond_setting}</span></p>` : ``}
            ${m.secondary_diamond_setting ? `<p><span class="prop body3 body3-left">Secondary ${isGem ? 'Gemstone' : 'Diamond' } Setting</span><span class="value body6 body6-left">${m.secondary_diamond_setting}</span></p>` : ``}
            ${m.primary_gemstone_clarity ? `<p><span class="prop body3 body3-left">Primary Gemstone Clarity</span><span class="value body6 body6-left">${m.primary_gemstone_clarity}</span></p>` : ``}
            ${m.secondary_gemstone_clarity ? `<p><span class="prop body3 body3-left">Secondary Gemstone Clarity</span><span class="value body6 body6-left">${m.secondary_gemstone_clarity}</span></p>` : ``}
            ${m.secondary_gemstone_type ? `<p><span class="prop body3 body3-left">Secondary Gemstone Type</span><span class="value body6 body6-left">${m.secondary_gemstone_type}</span></p>` : ``}
            ${m.secondary_gemstone_weight ? `<p><span class="prop body3 body3-left">Secondary Gemstone Weight</span><span class="value body6 body6-left">${m.secondary_gemstone_weight}</span></p>` : ``}`;
        }

        if(selectDoc('#set-products')) {
            let products = selectArr('#set-products input.set-piece'),
                details = selectDoc('#set-details');

            products.map(product => {
                ajax('GET', "/products/" + product.value + ".js")
                    .then(function (response) {
                        let productData = JSON.parse(response);
                        if (productData.status !== undefined) {
                            if (productData.status === 200) {
                                let productJS = JSON.parse(productData.response);
                                ajax('GET', "/products/" + product.value)
                                    .then(function (response) {
                                        let productData = JSON.parse(response);
                                        if (productData.status !== undefined) {
                                            if (productData.status === 200) {

                                                let varInd = product.getAttribute('data-variant'),
                                                    ind = 0;

                                                if(varInd) {
                                                    varInd = varInd.split(':');
                                                    if(varInd.length === 2) {
                                                        ind = varInd[1] > 0 ? varInd[1] - 1 : 0;
                                                    }
                                                }

                                                PDP.setsHiddenContainer.innerHTML = productData.response;
                                                let metafields = selectDoc(`[data-parent="V${productJS.id}"]`, PDP.setsHiddenContainer),
                                                    isGem = selectDoc('#is-gemstone', PDP.setsHiddenContainer);

                                                metafields = metafields ? JSON.parse(metafields.getAttribute('data-metafields').replace(/=>/g, ':')) : null;
                                                if(!metafields) {
                                                    metafields = selectDoc(`data[data-parent-id="${productJS.id}"]:nth-child(${ind + 1})`, PDP.setsHiddenContainer);
                                                    metafields = metafields ? JSON.parse(metafields.value.replace(/=>/g, ':')) : null;
                                                }
                                                metafields = metafields ?? {};
                                                PDP.setsHiddenContainer.innerHTML = '';

                                                let setPieceContent = '';
                                                if(Object.keys(metafields).length > 0) {

                                                    let summary = `${metafields.clarity} Clarity&nbsp;&nbsp;|&nbsp;&nbsp;${metafields.carat} Total Carat Weight&nbsp;&nbsp;|&nbsp;&nbsp;${metafields.metal}`;
                                                    if(isGem) {
                                                        summary = `${metafields.primary_gemstone_clarity} Clarity&nbsp;&nbsp;|&nbsp;&nbsp;${metafields.primary_diamond}&nbsp;&nbsp;|&nbsp;&nbsp;${metafields.metal}`;
                                                    }

                                                    setPieceContent = `<span class="icon"></span>
                                                                        <p class="sub-h3 sub-h3-left set-product-name">${productJS.title} - ${'$' + formatMoney(productJS.price, 0)}</p>
                                                                        <div class="body6 body6-left set-product-summary">${summary}</div>
                                                                        <div class="set-product-details">${renderDynamicProps(metafields, isGem)}</div>`;
                                                } else {
                                                    setPieceContent = `<span class="icon"></span>
                                                                        <p class="sub-h3 sub-h3-left set-product-name">${productJS.title} - ${'$' + formatMoney(productJS.price, 0)}</p>
                                                                        <div class="body6 body6-left set-product-summary">${productJS.variants.length > 0 ? productJS.variants[ind].title : ''}</div>
                                                                        <div class="set-product-details body3 body3-left">${productJS.description}</div>`;
                                                }

                                                let set = document.createElement('div');
                                                set.className = 'set-piece';
                                                set.style.order = product.getAttribute('data-pos');
                                                set.setAttribute('role', 'button');
                                                set.innerHTML = setPieceContent;
                                                details.appendChild(set);
                                                set.setAttribute('data-h', set.getBoundingClientRect().height);
                                                set.setAttribute('data-title', productJS.title);
                                                set.setAttribute('data-price', productJS.price);
                                                set.setAttribute('data-id', productJS.id);
                                                set.style.height = '100px';
                                                event(set, 'click', function () {
                                                    if(!selectDoc('.modal-container.active')) {
                                                        selectArr('.set-piece').map(piece => {
                                                            if(piece !== set) {
                                                                piece.style.height = '100px';
                                                                removeClass(piece, 'open');
                                                            }
                                                        });
                                                        toggleClass(set, 'open');
                                                        if(hasClass(set, 'open')) {
                                                            set.style.height = `${set.getAttribute('data-h')}px`;
                                                        } else {
                                                            set.style.height = '100px';
                                                        }
                                                    }
                                                });
                                            }
                                        }
                                    })
                            }
                        }
                    })
            })
        }
    }

    /**
     *
     * @param PDP
     * @returns {*}
     */
    initializer(PDP) {
        this.initVariants(PDP);
        this.initSet(PDP);
    }
}
